import React from 'react';
import { isArray } from 'lodash';

module.exports = function (WrappedComponent) {
  return React.createClass({

    propTypes: {
      error: React.PropTypes.object
    },

    getDefaultProps(){
      return {
        error: null
      }
    },

    render: function () {
      return <WrappedComponent {...this.props} error={this._getErrorMessage()}/>
    },

    _getErrorMessage(){
      var {error} = this.props;

      if (!error) {
        return null;
      }

      if (typeof error != "object") {
        return [error];
      }

      if (error.hasOwnProperty('modelState')) {
        return this._getFromModelState(error);
      }

      if (error.hasOwnProperty('message')) {
        return this._getFromMessage(error);
      }

      return this._unexpectedError();
    },

    _getFromModelState(error){
      var errorStack = [];
      for (var i in error.modelState) {
        if (!error.modelState.hasOwnProperty(i)) continue;

        if (isArray(error.modelState[i])) {
          errorStack = errorStack.concat(error.modelState[i]);
        } else {
          errorStack.push(error.modelState[i]);
        }
      }

      return errorStack;
    },

    _getFromMessage(error){
      return [error.message];
    },

    _unexpectedError(){
      return ["Unexpected Error"];
    }
  });

};


